import { render, staticRenderFns } from "./salesforce-send-company-widget.vue?vue&type=template&id=dba0b4a0&"
import script from "./salesforce-send-company-widget.vue?vue&type=script&lang=js&"
export * from "./salesforce-send-company-widget.vue?vue&type=script&lang=js&"
import style0 from "./salesforce-send-company-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports